type EventName =
  | 'auth_modal_opened'
  | 'auth_page_transition'
  | 'auth_modal_closed'
  | 'auth_logout_succeeded'
  | 'auth_logout_failed'
  | 'auth_set_acquisition_params'
  | 'auth_click'
  | 'auth_login_succeeded'
  | 'auth_login_failed'
  | 'auth_sign_up_succeeded'
  | 'auth_sign_up_failed'
  | 'auth_social_sign_up_succeeded'
  | 'auth_social_login_succeeded'
  | 'auth_social_sign_up_failed'
  | 'auth_social_login_failed'
  | 'auth_update_profile_succeeded'
  | 'auth_update_profile_failed'
  | 'auth_register_acquisition_user_succeeded'
  | 'auth_register_acquisition_user_failed'
  | 'auth_password_reset_succeeded'
  | 'auth_password_reset_failed'
  | 'auth_set_acquisition_params_succeeded'
  | 'auth_set_acquisition_params_failed'
  | 'thank_you';

interface LocationDetails {
  parentUrl: string;
  pathname: string;
  screenId: string;
  pageName: string;
}

interface EventProperties {
  action?: string;
  error?: string;
  parentUrl?: string;
  pathname?: string;
  screenId?: string;
  pageName?: string;
  params?: { vendorId: number; vendorUserId: string };
  providerId?: string;
}

export const trackEvent = (event: EventName, properties?: EventProperties) => {
  try {
    (window as any)?.analytics.track(event, properties);
  } catch (error) {
    console.error('analytics error', error);
  }
};

export const getLocationDetails = (pathname: string, search: string): LocationDetails | {} => {
  const searchParams = search && new URLSearchParams(search);

  const iframeLocation = (searchParams && searchParams.get('iframeLocation')) || '';
  const parentUrl = (searchParams && searchParams.get('parentUrl')) || '';

  switch (pathname) {
    case '/sign-up/acquisition':
      return {
        parentUrl,
        pathname,
        screenId: '1-1',
        pageName: 'sign-up acquisition',
        iframeLocation,
      };
    case '/sign-up':
      return {
        parentUrl,
        pathname,
        screenId: '1-2',
        pageName: 'sign-up methods listed',
        iframeLocation,
      };
    case '/sign-up/check-info':
      return {
        parentUrl,
        pathname,
        screenId: '1-3.2',
        pageName: 'sign-up check information',
        iframeLocation,
      };
    case '/sign-up/detailed':
      return {
        parentUrl,
        pathname,
        screenId: '1-3',
        pageName: 'sign-up detailed',
        iframeLocation,
      };
    case '/sign-up/additional-questions':
      return {
        parentUrl,
        pathname,
        screenId: '1-3.n.1',
        pageName: 'sign-up additional questions',
        iframeLocation,
      };
    case '/login':
      return {
        parentUrl,
        pathname,
        screenId: '1.0',
        pageName: 'login form',
        iframeLocation,
      };
    case '/login/help':
      return {
        parentUrl,
        pathname,
        screenId: '3.0',
        pageName: 'login help',
        iframeLocation,
      };
    case '/login/help/email-sent':
      return {
        parentUrl,
        pathname,
        screenId: '2.0',
        pageName: 'confirmation email sent',
        iframeLocation,
      };
    case '/login/help/password-reset-confirmation':
      return {
        parentUrl,
        pathname,
        screenId: '5.0',
        pageName: 'password reset confirmation',
        iframeLocation,
      };
    case '/sign-up/thank-you':
      return {
        parentUrl,
        pathname,
        screenId: '6.n',
        pageName: 'thank you',
        iframeLocation,
      };
    default:
      return {
        iframeLocation,
      };
  }
};
